import { useEffect, useState } from 'react'

/**
 * Keeps an overlay mounted long enough to play its exit animation.
 * Render while `mounted`, and put `data-state={state}` on the animated node.
 */
export function usePresence(open: boolean, exitMs = 220) {
  const [mounted, setMounted] = useState(open)

  if (open && !mounted) setMounted(true)

  useEffect(() => {
    if (open || !mounted) return
    const reduced = document.documentElement.dataset.motion === 'reduced'
    const timer = setTimeout(() => setMounted(false), reduced ? 0 : exitMs)
    return () => clearTimeout(timer)
  }, [open, mounted, exitMs])

  return { mounted: mounted || open, state: (open ? 'open' : 'closed') as 'open' | 'closed' }
}
